import React from "react";
import NumberFormat from "react-number-format";
import {RequiredAstrix} from "./FormElements";
import {Field} from "formik";
import PropTypes from 'prop-types';

const NumberField = (props) => {
    const {
        id,
        name,
        maxLength,
        allowNegative,
        className,
        label,
        required
    } = props;

    return (
        <Field name={name}>
            {({field: {name, value}, form: {handleChange, handleBlur, touched, errors}}) => {
                return (
                    <div className={'form-group'}>
                        {label && <label htmlFor={id} className={'heading'}>{label} {required && <RequiredAstrix />}</label>}
                        <NumberFormat
                            id={id}
                            type={'text'}
                            name={name}
                            allowNegative={allowNegative}
                            onChange={handleChange}
                            value={value}
                            className={`form-control ${className}`}
                            autoComplete={'off'}
                            onBlur={handleBlur}
                            maxLength={maxLength}
                        />
                        {touched[name] && errors[name] &&
                        <span className={'invalid'}>{errors[name]}</span>}
                    </div>
                )
            }}
        </Field>
    )
}

NumberField.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    maxLength: PropTypes.number,
    allowNegative: PropTypes.bool,
    className: PropTypes.string,
    label: PropTypes.string,
    required: PropTypes.bool
}

NumberField.defaultProps = {
    allowNegative: true,
    id: null,
    className: null,
    label: null,
    required: false
}

export default NumberField;
